<template>
  <div class="header">
    <div class="header-wrapper">
      <router-link :to="{name: 'TOP'}" class="header-logo">
        <img src="@/assets/img/ico_logo_zengo.svg"/>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBeforeLogin',
  methods: {
    openSidebar () {
      this.$emit('openSidebar', true)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/HeaderBeforeLogin.vue